import React from 'react';
import { Button as MuiButton } from '@mui/material';

function Button({ 
  children, 
  onClick, 
  variant = 'contained', 
  color = 'primary',
  size = 'medium', 
  type = 'button',
  disabled = false,
  startIcon,
  endIcon,
  fullWidth = false,
  className = '',
  ...otherProps
}) {
  const getButtonStyles = () => {
    if (variant === 'contained' && color === 'primary') {
      return {
        background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
        boxShadow: '0 4px 15px rgba(99, 102, 241, 0.4)',
        borderRadius: '10px',
        textTransform: 'none',
        fontWeight: 600,
        padding: size === 'large' ? '12px 32px' : size === 'small' ? '6px 16px' : '10px 24px',
        transition: 'all 0.3s ease',
        '&:hover': {
          background: 'linear-gradient(135deg, #4f46e5 0%, #9333ea 100%)',
          boxShadow: '0 6px 25px rgba(99, 102, 241, 0.5)',
          transform: 'translateY(-2px)'
        },
        '&:active': {
          transform: 'translateY(0px)'
        }
      };
    }

    // Support for danger/error variant
    if (variant === 'contained' && color === 'error') {
      return {
        background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
        boxShadow: '0 4px 15px rgba(239, 68, 68, 0.4)',
        borderRadius: '10px',
        textTransform: 'none',
        fontWeight: 600,
        padding: size === 'large' ? '12px 32px' : size === 'small' ? '6px 16px' : '10px 24px',
        transition: 'all 0.3s ease',
        color: '#fff',
        '&:hover': {
          background: 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)',
          boxShadow: '0 6px 25px rgba(239, 68, 68, 0.5)',
          transform: 'translateY(-2px)'
        },
        '&:active': {
          transform: 'translateY(0px)'
        }
      };
    }
    
    if (variant === 'outlined') {
      const isError = color === 'error';
      return {
        borderRadius: '10px',
        textTransform: 'none',
        fontWeight: 600,
        borderWidth: '2px',
        borderColor: isError ? '#ef4444' : '#6366f1',
        color: isError ? '#ef4444' : '#6366f1',
        transition: 'all 0.3s ease',
        '&:hover': {
          borderWidth: '2px',
          borderColor: isError ? '#dc2626' : '#4f46e5',
          background: isError ? 'rgba(239, 68, 68, 0.05)' : 'rgba(99, 102, 241, 0.05)',
          transform: 'translateY(-1px)'
        }
      };
    }
    
    return {
      borderRadius: '10px',
      textTransform: 'none',
      fontWeight: 600
    };
  };

  return (
    <MuiButton 
      variant={variant}
      color={color}
      size={size}
      onClick={onClick} 
      type={type}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
      fullWidth={fullWidth}
      className={className}
      sx={getButtonStyles()}
      {...otherProps}
    >
      {children}
    </MuiButton>
  );
}

export default Button;
